import { post } from "../methods";
function userRegister(payload, headers = {}) {
  return post({
    url: "backend/auth/register",
    payload,
    headers
  });
}
export {
  userRegister as default
};
